<template lang='pug'>
#home
	Header
	Section1
	Section2
	Schedule
	Section3
	Section4
	Footer
</template>

<script>
import Header from '@/components/Header.vue';
import Section1 from '@/components/Section1.vue';
import Section2 from '@/components/Section2.vue';
import Schedule from '@/components/Schedule.vue';
import Section3 from '@/components/Section3.vue';
import Section4 from '@/components/Section4.vue';
import Footer from '@/components/Footer.vue';
export default {
	name: 'Home',
	components: { Header, Section1, Section2, Schedule, Section3, Section4, Footer }
};
</script>
